import _get from 'lodash/get'

import axios from '../../_framework/axios/trip-dashboard-axios'

export default {
  state: {
    collection: _get(window, 'appInitialData.stores.ToDoTemplates', [])
  },
  getters: {
    TodoTemplates: state => {
      return state.collection
    }
  },
  mutations: {
    updateTodoTemplates(state, payload) {
      state.collection = payload.templates
    }
  },
  actions: {
    getTodoTemplates(context) {
      window.axios.get('/getTodoTemplates').then(response => {
        if (response.status === 200) {
          context.commit('updateTodoTemplates', response.data)
        }
      })
    },
    addTodoTemplate(context, payload) {
      axios.post('/addTodoTemplate', payload).then(response => {
        if (response.status === 200) {
          context.commit('updateTodoTemplates', response.data)
        }
      })
    },
    updateTodoTemplate(context, payload) {
      axios.post(`/updateTodoTemplate/${payload.template.id}`, payload).then(response => {
        if (response.status === 200) {
          context.commit('updateTodoTemplates', response.data)
        }
      })
    },
    removeTodoTemplate(context, payload) {
      axios.post(`/removeTodoTemplate/${payload.template.id}`, payload).then(response => {
        if (response.status === 200) {
          context.commit('updateTodoTemplates', response.data)
        }
      })
    },
    importTodoTemplate(context, payload) {
      axios
        .post(
          `${context.getters.currentTripDashboardId}/importTodoListTemplate/${payload.template.id}`
        )
        .then(response => {
          if (response.status === 200) {
            context.commit('updateTripEventsAndTodoItems', response.data)
          }
        })
    }
  }
}
